import React from 'react';
import { hot } from 'react-hot-loader';
import { translate } from '../../../utils/locale';
import s from './SectionTitle.scss';

const SectionTitle = ({ setup, content }) => {
	if (!content?.acfSectionTitle?.content?.title) return null;
	return (
		<div className={s.sectionTitle}>
			{ translate(setup, content?.acfSectionTitle?.content.title) }
		</div>
	);
};

export default hot(module)(SectionTitle);
